import { render, staticRenderFns } from "./TifVentanaGeneralOperacionesCambios.vue?vue&type=template&id=93c3bab0"
import script from "./TifVentanaGeneralOperacionesCambios.vue?vue&type=script&lang=js"
export * from "./TifVentanaGeneralOperacionesCambios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports